import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { makeStyles } from '@material-ui/styles';
import { Box, Typography, Grid, Divider } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import DealerSummary from './dealer-summary';
import OrderSummary from './order-summary';
import ClaimInformation from './claim-information';
import RequiredFieldsFormLabel from 'src/components/RequiredFieldsFormLabel';
import ContactSummary from './contact-summary'; import { pad } from 'lodash';

const useStyles = makeStyles((theme) => ({
  root: {},
  marginBottom: {
    marginBottom: 20
  },
  divider: {
    marginBottom: 20,
    marginTop: 20
  },
  claimTypeContainer: {
    height: '50px'
  },
  dateOfLoss: {
    lineHeight: 2
  },
  sectionHeader: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(0.5),
    '& h6': {
      color: theme.palette.secondary.main,
      marginRight: theme.spacing(1),
    }
  },
}));

const ClaimHeader = ({
  dealerInfo,
  orderInfo = null,
  claimContactInfo = null,
  claimInfo = null,
  showTitle = true,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const Title = () => {
    if (!showTitle) return null;

    if (dealerInfo && orderInfo && claimContactInfo && !claimInfo) {
      return (

        <>
          <Box display="flex" style={{ marginTop: 24 }} >
            <Typography variant="h3" color="textPrimary">
              {t('glassClaim.title')}
            </Typography>
            <Box ml={1} />
            <Typography
              variant="subtitle1"
              color="textSecondary"
              className={classes.dateOfLoss}
            >
              {t('glassClaim.claimDateLabel')}: {moment().format('MMM DD, YYYY')}
            </Typography>
          </Box>
          <RequiredFieldsFormLabel />
        </>
      );
    }
  }

  return (
    <Grid container justifyContent="space-between" alignItems="center" style={{ padding: 16, paddingTop: 0, marginTop: -24 }} >
      <Grid item xs={12} >
        {dealerInfo && (
          <Grid container>
            <Grid item xs={12} className={classes.sectionHeader}>
              <Typography variant="h6" color="textSecondary">
                {t('glassClaim.dealerInformation')}
              </Typography>
              <Divider />
            </Grid>
            <DealerSummary dealerInfo={dealerInfo} />
          </Grid>

        )}
      </Grid>
      <Grid item xs={12} >
        {orderInfo && (
          <Grid container>
            <Grid item xs={12} className={classes.sectionHeader}>
              <Typography variant="h6" color="textSecondary">
                {t('glassClaim.orderInformation')}
              </Typography>
              <Divider />
            </Grid>
            <OrderSummary orderInfo={orderInfo} />
          </Grid>
        )}
      </Grid>
      <Grid item xs={12} >
        {claimContactInfo && (
          <Grid container>
            <Grid item xs={12} className={classes.sectionHeader}>
              <Typography variant="h6" color="textSecondary">
                {t('glassClaim.contactInformation')}
              </Typography>
              <Divider />
            </Grid>
            <ContactSummary emailAddress={claimContactInfo.emailAddress}
              contactName={claimContactInfo.contactName ? claimContactInfo.contactName : `${claimContactInfo.firstName ?? ''} ${claimContactInfo.lastName ?? ''}`}
              phoneNumber={claimContactInfo.phoneNumber} />
          </Grid>
        )}
      </Grid>
      <Grid item xs={12} >
        {claimInfo && (
          <Grid container>
            <Grid item xs={12} className={classes.sectionHeader}>
              <Typography variant="h6" color="textSecondary">
                {t('glassClaim.claimInformation')}
              </Typography>
              <Divider />
            </Grid>
            <ClaimInformation claimInfo={claimInfo} />
          </Grid>
        )}
      </Grid>
      <Grid item xs={12} >
        {Title()}
      </Grid>
    </Grid>
  );
};

ClaimHeader.propTypes = {
  dealerInfo: PropTypes.object,
  orderInfo: PropTypes.object,
  claimContactInfo: PropTypes.object,
  claimInfo: PropTypes.object,
  showTitle: PropTypes.bool
};

export default ClaimHeader;
